import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URI } from '../../environments/environment';
import { LoadingService } from './loading.service';
import { HttpClient } from '@angular/common/http';

export type Emergencia = {
  userId: string;
  descripcion: string;
  prioridad?: 'alta' | 'media' | 'baja';
  ubicacion?: { lat: number; lng: number } | null;
  estado?: 'abierta' | 'atendida';
  creadaEn?: any;
  atendidaEn?: any;
};

@Injectable({
  providedIn: 'root'
})
export class OrderEmergenciaService {
  private http = inject(HttpClient);
  private _loadingService = inject(LoadingService);
  private readonly API = API_URI + 'app';

  /**
   * Envía la solicitud de WhatsApp de emergencia.
   * @param id_cliente UID del cliente
   * @param showLoader Si true, muestra el loader global mientras se realiza la petición
   */
  sendWhatsappEmergency(id_cliente: string, showLoader: boolean = true): Observable<any> {
    const data = { id_cliente };
    const req$ = this.http.post<any>(`${this.API}/whatsapp/whatsappSendEmergency/`, data);
    return showLoader ? this._loadingService.run$(req$) : req$;
  }
}
